/**
 * HubSpot forms for [data-hubspot-form] placeholders.
 * Portal/region come from Theme Settings (window.curadenHubspot).
 */
const init = () => {
	const cfg = window.curadenHubspot || {};
	if ( ! cfg.portalId || ! window.hbspt ) {
		return;
	}
	document.querySelectorAll( '[data-hubspot-form]' ).forEach( ( el ) => {
		const formId = el.dataset.hubspotForm;
		el.removeAttribute( 'data-hubspot-form' );
		window.hbspt.forms.create( {
			region: cfg.region || 'eu1',
			portalId: cfg.portalId,
			formId,
			target: `#${ el.id }`,
			css: '',
			submitButtonClass: cfg.submitButtonClass,
		} );
	} );
};

document.readyState === 'loading' ? document.addEventListener( 'DOMContentLoaded', init ) : init();
